(function() {
'use strict';

angular
    .module('dashboard')
    .controller('DashboardSettings', Settings);

function Settings($rootScope,
                  $scope,
                  userSettingsService,
                  preferences,
                  currentUser,
                  authService,
                  resourceService,
                  arrayUtil,
                  broker,
                  paymentDetailsService,
                  paymentsService,
                  tokeniser,
                  $timeout,
                  $q,
                  mybTrack) {
    const cm = this;
    const thisYear = new Date().getFullYear();
    let confirmed = false;

    cm.starRatings = userSettingsService.getStarRatings();
    cm.smokingRoom = userSettingsService.getSmokingRoomOptions();
    cm.footerToolbar = userSettingsService.getFooterToolbarOptions();
    cm.flightClass = userSettingsService.getFlightClassOptions();
    cm.hotelSortOrder = userSettingsService.getHotelCriteria();
    cm.flightSortOrder = userSettingsService.getFlightCriteria();
    cm.priceMode = userSettingsService.getPricMode();
    cm.titles = userSettingsService.getAdultTitles();
    cm.canceledBooking = userSettingsService.getCanceledBookingOprions();


    cm.savePreferences = saveUserPreferences;
    cm.cancelPreferences = cancelPreferences;
    cm.openChangePasswordPanel = openChangePasswordPanel;
    cm.closeChangePassword = closeChangePassword;
    cm.openChangeEmailPanel = openChangeEmailPanel;
    cm.changeContactDetails = changeContactDetails;
    cm.openEditContact = openEditContact;
    cm.changeEmail = changeEmail;
    cm.closeChangeEmail = closeChangeEmail;
    cm.changePassword = changePassword;
    cm.confirmRemoveCard = confirmRemoveCard;
    cm.closeEditRemoveCard = closeEditRemoveCard;
    cm.addCardDetails = addCardDetails;
    cm.addNewCard = addNewCard;
    cm.removeCard = removeCard;
    cm.cancelLoginDetailsChange = cancelLoginDetailsChange;

    cm.user = $rootScope.user;

    cm.months = arrayUtil.numberArray(1, 12);
    cm.years = arrayUtil.numberArray(thisYear, thisYear + 20);
    cm.deleteAccount = deleteAccount;

    cm.deleteButton = resourceService.getDeferred('DELETEACCOUNT');
    cm.deleteAccountConfirmed = deleteAccountConfirmed;
    cm.closeConfirmDeleteAccount = closeConfirmDeleteAccount;
    cm.showConfirmDeleteAccount = showConfirmDeleteAccount;
    cm.padZero = padZero;
    cm.getResourceValue = resource => resourceService.get(resource);

    const prefrenceOptionsMap = {
        starRatings: cm.starRatings,
        flightSortOrder: cm.flightSortOrder,
        hotelSortOrder: cm.hotelSortOrder,
        smokingRoom: cm.smokingRoom,
        priceMode: cm.priceMode,
        footerToolbar: cm.footerToolbar,
        flightClass: cm.flightClass,
        canceledBooking: cm.canceledBooking
    };

    const savedFrom = {
        SettingsTab: 1,
        BookingForm: 2
    };

    let userPreferenceBeforeChange = null;

    mybTrack.track('MYB - My Settings');

    function getPreferences() {
        let prefs = {};
        prefs.starRatings = cm.starRatings[0];
        prefs.flightSortOrder = cm.flightSortOrder[0];
        prefs.hotelSortOrder = cm.hotelSortOrder[0];
        prefs.smokingRoom = cm.smokingRoom[0];
        prefs.footerToolbar = cm.footerToolbar[1];
        prefs.priceMode = cm.priceMode[0];
        prefs.flightClass = cm.flightClass[0];
        prefs.canceledBooking = cm.smokingRoom[1];
        return preferences.getAllPreferences(cm.user).then(function(result) {
            prefs = organiseUserPreferenceData(prefs, result);
            userPreferenceBeforeChange = angular.copy(prefs);
            return prefs;
        });
    }

    getPreferences().then(p => { cm.userPreferences = p; });

    function savePreferences(prefs) {
        const prefsToBeSaved = {};
        angular.forEach(prefs, function(v, k) {
            prefsToBeSaved[k] = v.val instanceof Array ? v.val[0] : v.val;
        });

        preferences.setAllPreferences(prefsToBeSaved, cm.user).then(function() {
            cm.userPreferences = organiseUserPreferenceData(cm.userPreferences, prefsToBeSaved);
            userPreferenceBeforeChange = angular.copy(cm.userPreferences);
            cm.editHotelPref = false;
            cm.editFlightPref = false;
            cm.editSitePref = false;
        });
    }

    function saveUserPreferences() {
        if (cm.userPreferences.footerToolbar !== userPreferenceBeforeChange.footerToolbar) {
            broker.publish('footerToolbarChanged', cm.userPreferences.footerToolbar.val);
        }
        savePreferences(cm.userPreferences);
    }

    function cancelPreferences() {
        angular.forEach((userPreferenceBeforeChange), function(value, key) {
            const arrayToLook = prefrenceOptionsMap[key];
            const index = arrayUtil.indexOf(arrayToLook, function(item) {
                const itemVal = item.val instanceof Array ? item.val[0] : item.val;
                const valueVal = value.val instanceof Array ? value.val[0] : value.val;
                return itemVal === valueVal;
            });
            cm.userPreferences[key] = arrayToLook[index];
        });
        cm.editHotelPref = false;
        cm.editFlightPref = false;
        cm.editSitePref = false;
    }

    function organiseUserPreferenceData(prefs, userPreferences) {
        for (const key in prefs) {
            setModelForPreference(key, prefs, userPreferences);
        }
        return prefs;
    }

    function setModelForPreference(key, prefs, userPreferences) {
        const arrayToLook = prefrenceOptionsMap[key];
        if (arrayToLook && userPreferences[key] !== undefined) {
            for (let i = 0; i < arrayToLook.length; i++) {
                const checkVal = arrayToLook[i].val instanceof Array ? arrayToLook[i].val[0] : arrayToLook[i].val;
                if (userPreferences[key].toString() === checkVal.toString()) {
                    prefs[key] = arrayToLook[i];
                    break;
                }
            }
        } else if (arrayToLook) {
            prefs[key] = arrayToLook[0];
        }
    }

    function openChangePasswordPanel() {
        cm.showChangePassword = true;
    }

    function closeChangePassword() {
        cm.showChangePassword = false;
    }

    function openChangeEmailPanel() {
        cm.userEdit = angular.copy(cm.user);
        cm.showChangeEmail = true;
    }

    function closeChangeEmail() {
        cm.showChangeEmail = false;
    }

    function changeContactDetails() {
        authService.changeContactDetails(cm.userEdit).then(function() {
            cm.editContact = false;
            currentUser.set(cm.userEdit);
            $rootScope.user = currentUser.get();
            cm.user = $rootScope.user;
        });
    }

    function openEditContact() {
        cm.editContact = true;
        cm.userEdit = angular.copy(cm.user);
    }

    function changeEmail(model) {
        authService.changeEmail({
            Password: model.currentPassword,
            NewEmail: model.email
        }).then(function(res) {
            if (res.Result !== 0) {
                $scope.$broadcast('flash:error', resourceService.get('CHANGEEMAILFAILURE'));
            }
        });
    }

    function changePassword(model) {
        authService.changePassword({
            Password: model.currentPassword,
            NewPassword: model.newPassword
        }).then(function(res) {
            if (res.Result === 0) {
                $scope.$broadcast('flash:success', resourceService.get('CHANGEPASSWORDSUCCESS'));
                closeChangePassword();
            } else {
                $scope.$broadcast('flash:error', resourceService.get('CHANGEPASSWORDFAILURE'));
            }
        });
    }

    function cancelLoginDetailsChange() {
        cm.showChangeEmail = false;
        cm.showChangePassword = false;
        cm.changeEmailModel = null;
        cm.changePasswordModel = null;
        $scope.$broadcast('flash:hide');
    }

    broker.subscribe('dashboardSettingsCtrl', 'footerToolbarChanged', function(ev) {
        cm.userPreferences.footerToolbar = ev.data ? cm.footerToolbar[0] : cm.footerToolbar[1];
    });

    $scope.$on('$destroy', function() {
        broker.unsubscribe('dashboardSettingsCtrl', 'footerToolbarChanged');
    });

    function confirmRemoveCard(card) {
        card.showConfirmRemoveCard = true;
    }

    function closeEditRemoveCard(card) {
        card.showConfirmRemoveCard = false;
    }

    function _refreshPaymentCards() {
        paymentDetailsService.getPaymentCards().then(function(result) {
            cm.paymentCards = result;
        });
    }

    function addNewCard() {
        cm.addCard = true;
        cm.cardChangedTo = undefined;
        cm.paymentSuccess = false;
    }

    function addCardDetails(card) {
        const today = new Date();
        if (card.ExpiryDate.Year === today.getFullYear() && card.ExpiryDate.Month < today.getMonth() + 1) {
            cm.CardHasExpired = true;
        } else {
            cm.addingCard = true;
            cm.CardHasExpired = false;
            paymentsService.addCardDetails(card, savedFrom.SettingsTab).then(function() {
                cm.addCard = false;
                cm.newCard = null;
                cm.addingCard = false;
                _refreshPaymentCards();
                cm.paymentSuccess = true;
                $timeout(function() {
                    cm.paymentSuccess = false;
                }, 5000);
            });
        }
    }

    function removeCard(card) {
        paymentsService.removeCard(card.CardId).then(function() {
            _refreshPaymentCards();
            closeEditRemoveCard(card);
        });
    }

    if (TRPCONFIG.Domain.SavedCardsEnabled) {
        const uniqueMasterCards = true; // if uniqueMasterCards is requested. return unique types with respect to MasterdCardId.
        paymentDetailsService.getPaymentTypes(uniqueMasterCards).then(function(result) {
            cm.paymentTypes = result;
        });

        paymentDetailsService.getPaymentTypes().then(function(result) {
            cm.allPaymentTypes = result;
        });
        _refreshPaymentCards();
    }

    cm.generateTokens = () => {
        //figure out if we need to generate tokens and if there should be an expiry
        //if pci compliant
        const requireTokens = TRPCONFIG.Domain.PCICompliant;
        const newCard = cm.newCard || { ExpiryDate: {} };
        const month = newCard.ExpiryDate ? newCard.ExpiryDate.Month : null;
        const year = newCard.ExpiryDate ? newCard.ExpiryDate.Year : null;
        const expiryDate = month != null && year != null ? new Date(year, month) : null;

        if (!expiryDate) {
            return $q.when();   //no point tokenising because the form is not valid
        }

        if (requireTokens) {
            return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
        }
        return $q.when();
    };

    cm.checkCreditCardNumber = function(cardNumber) {
        cm.cardChangedTo = undefined;
        if (!cardNumber) { return; }

        paymentsService
            .checkCardNumber(cm.allPaymentTypes, cardNumber, cm.newCard.paymentType)
            .then(undefined, function setCorrectCard(correctId) {
                for (let i = 0; i < cm.allPaymentTypes.length; i++) {
                    if (cm.allPaymentTypes[i].CardTypeId === correctId && cm.newCard.paymentType !== cm.allPaymentTypes[i].MasterCardTypeId) {
                        cm.newCard.paymentType = cm.allPaymentTypes[i].MasterCardTypeId;
                        cm.cardChangedTo =
                            paymentsService.getCardTitle(cm.allPaymentTypes, correctId);
                        break;
                    }
                }
            });
    };

    cm.updateCardType = function() {
        cm.newCard.CardNumber = undefined;
        cm.cardChangedTo = undefined;
    };

    function deleteAccount(password) {
        if (!confirmed) {
            cm.deleteButton = resourceService.getDeferred('CONFIRMDELETE');
            confirmed = true;
            return;
        }
        authService.deleteAccount({
            Password: password
        }).then(function(resp) {
            if (!resp.Success) {
                cm.deleteButton = resourceService.getDeferred('DELETEACCOUNT');
                confirmed = false;
                cm.showconfirmDeleteAccount = false;
                $scope.$broadcast('flash:error', resourceService.get('DELETEACCOUNTFAILURE'));
            }
        });
    }

    function deleteAccountConfirmed(password) {
        confirmed = true;
        deleteAccount(password);
    }

    function showConfirmDeleteAccount() {
        cm.showconfirmDeleteAccount = true;
        $scope.$broadcast('flash:hide');
    }

    function closeConfirmDeleteAccount() {
        cm.showconfirmDeleteAccount = false;
        confirmed = false;
    }

    function padZero(n) {
        return (n < 10) ? (`0${n}`) : n;
    }
}
})();
